import { getEndpointForService } from 'reducers/configs/serviceEnpoints';
import { REDUX_CLIENTCODE, REDUX_SESSIONKEY } from 'constants/persistence';
import { ObfuscatedLocalStorage } from 'utils/ObfuscatedLocalStorage';

import { proxy } from '../shared';

/**
 * Allows non-GoErp applications to send Events to GoErp template applications.
 *
 * @param action  the name of the EventSource that should receive the emmited event
 * @param message the data sent via the Server Side Event. Must be a serializable value
 */
export function sendEventsToSSE(action: string, message: any) {
  const { url: apiEndpoint } = getEndpointForService('goerp');
  const clientCode = JSON.parse(
    ObfuscatedLocalStorage.getItem(REDUX_CLIENTCODE) ?? '""',
  );
  const sessionKey = JSON.parse(
    ObfuscatedLocalStorage.getItem(REDUX_SESSIONKEY) ?? '""',
  );

  const endpoint = 'v2/template-stream-action/';

  const baseUrl = `${proxy}${apiEndpoint}${endpoint}${action}`;

  const myHeaders = new window.Headers();
  myHeaders.append('clientCode', clientCode);
  myHeaders.append('sessionKey', sessionKey);

  const requestOptions: RequestInit = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(message),
    redirect: 'follow',
  };

  return window
    .fetch(baseUrl, requestOptions)
    .then(response => response.text());
}
